export default __webpack_public_path__ + "static/media/mm-logo-white.2cce7fa4.png";